/**
 * 客户信息
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, DatePicker, Button, Input,Select } from 'antd';
import PageLayout from '../../ui/PageLayout';
//客户信息
import OutsideVehicleOrderEdit from './OutsideVehicleOrderEdit';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import {getBase64} from '../../../util/util.js';
import { global_data } from '../../ui/auth'

class OutsideVehicleOrderIndex extends React.Component {

    columns = [
     {
        title: '车架号',
        dataIndex: 'vin',
        width: '12%'
    }
    , {
        title: '合同金额',
        dataIndex: 'amount',
        width: '8%'
    }
    , {
        title: '开票日期',
        dataIndex: 'invoiceDate',
        width: '10%'
    }
    , {
        title: '合同类型',
        dataIndex: 'type',
        width: '8%',
        format: { 
            0: '采购'
            , 1: '销售' 
        }
    }
    , {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("OUTSIDE_ORDER_INDEX_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("OUTSIDE_ORDER_INDEX_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record.id)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        amount:'0'
    };

    componentDidMount() {
        this.loadOrderSum(this.state.queryData);
    }

    loadOrderSum = (queryData) => {
        http.get({
            url: '/outsideVehicleOrder/sum',
            data: queryData,
            success: (res) => {
                this.setState({
                    amount: res.amount 
                });
            }
        });
    }

    loadPageData = (queryData) => {
        this.state.loadData(queryData);
        this.loadOrderSum(queryData);
    }

    add = () => {
        this.setState({ visible: true, editData: {} });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {}, interactionVisible: false});
    };

    update = (info, e) => {
        this.setState({ editData: info, visible: true});
    }

    delete = (id, e) => {
        messager.confirm("是否删除该合同信息？", () => {
            http.post({
                url: '/outsideVehicleOrder/delete',
                data: { id: id },
                success: (res) => {
                    this.loadPageData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadPageData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.loadPageData(queryData);
    }

    selectChange = (filed, value) => {
        let queryData = this.state.queryData;
        queryData[filed] = value;
        this.setState({ queryData: queryData });
        this.loadPageData(queryData);
    }
    //选择文件上传
    uploadFile = (e) =>{
        this.setState({ loadingVisible: true });
        let file = e.target.files[0];
        getBase64(file).then(base64 => {
            http.post({
                url: '/outsideVehicleOrder/import',
                data: {
                    "fileName": file.name,
                    "file" : base64
                },
                success: (res) => {
                    this.setState({ loadingVisible: false });
                    messager.notify("上传成功！");
                    this.loadPageData(this.state.queryData)
                },
                error: (res) => {
                    messager.alert(res);
                    this.setState({ loadingVisible: false });
                }
            });
        });
        e.target.value=''
    }

    // 导出
  download = () => {
    let queryData = this.state.queryData;
    if (queryData.startDate == null || queryData.endDate === "") {
        messager.notify("导出时需选择时间段！", null, "warning");
        return;
    }
    this.setState({ loadingVisible: true });
    let fileName = queryData.startDate + "~" + queryData.endDate + "-vehicle-purchase-detail.xlsx";
    http.download({
      url: '/outsideVehicleOrder/excel',
      data: queryData,
      fileName: fileName,
      success: (res) => {
        this.setState({ loadingVisible: false });
      }
    });
    messager.notify("只会根据查询的时间段导出已经打印的数据！");
  }
    //下载模板
    downloadTemplate = () => {
        this.setState({ loadingVisible: true });
        http.download({
            url: '/outsideVehicleOrder/downloadTemplate',
            fileName: "门店柏亿合同导入模板.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={19}>
                                <Input.Search
                                    placeholder="车架号"
                                    onSearch={this.inputSearch.bind(this, "vin")}
                                    style={{ width: 150}}
                                    enterButton
                                />
                                <Select onChange={this.selectChange.bind(this,"type")} allowClear={true} placeholder="合同类型" style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option key={0}>采购</Select.Option>
                                    <Select.Option key={1}>销售</Select.Option>
                                </Select>
                                <DatePicker.RangePicker placeholder={['开票', '日期']} allowClear={true} onChange={this.rangePickerChange} style={{marginLeft: '10px' }} />
                                <Button type='text' style={{marginLeft: '10px',paddingTop:'0px'}}>总合同金额：{this.state.amount}</Button>
                            </Col>
                            <Col span={5}>
                                {global_data.authCode.includes("OUTSIDE_ORDER_INDEX_ADD")?
                                <Button type="primary" onClick={this.add} style={{ float: "right"}}>新增</Button>
                                :""}
                                {global_data.authCode.includes("OUTSIDE_ORDER_INDEX_IMPORT")?
                                <Button type="primary" onClick={()=>{this.refs.fileInput.click()}} style={{"margin":"0 10px","float":"right"}}>导入</Button>
                                :""}
                                <Button type="primary" onClick={this.downloadTemplate} style={{"margin":"0 10px","float":"right"}}>下载模板</Button>
                                <input type="file" accept=".xlsx" onChange={this.uploadFile.bind(this)} style={{ display: "none" }} ref="fileInput" />
                                <Button type="primary" onClick={this.download.bind(this)} style={{"margin":"0 10px","float":"right"}} >导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/outsideVehicleOrder/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <OutsideVehicleOrderEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.loadPageData}
                    queryData={this.state.queryData}
                    initTypeDict={(func) => {this.setState({initTypeDict: func})}}
                />
            </div>
        )
    }
}

export default OutsideVehicleOrderIndex;